// Module
var code = "<div class=\"widget-content text-center\"> <wt-loading-panel is-loading=\"vm.isLoading\"></wt-loading-panel> <wt-new-gauge class=\"flex-directive\" component-id=\"{{vm.id}}\" data=\"vm.gauge.data\" options=\"vm.gauge.options\" ratio=\"vm.ratio\"> </wt-new-gauge> </div>";
// Exports
module.exports = code;